/** 28.09 (владелец: «история таких перемещений должна сохраняться, чтобы если что можно было
 *  разобрать какую-то ситуацию»): заявки админа зала за день — что просил, когда, почему,
 *  кто из ОО решил и чем кончилось. Ждущие можно отозвать. Строки не удаляются никогда. */
import { useState } from "react";
import type { HallReq } from "../../hooks/useHallDay";
import h from "./hallAdmin.module.css";

const STATUS: Record<HallReq["status"], string> = { pending: "ждёт ОО", approved: "одобрено", rejected: "отклонено", failed: "не применилось", cancelled: "отозвано" };
/** UTC из базы → «17:42» по Оренбургу */
export const hhmm = (at: string | null) => {
  if (!at) return "";
  const t = Date.parse(at.includes("T") ? at : `${at.replace(" ", "T")}Z`);
  if (!Number.isFinite(t)) return "";
  const d = new Date(t + 5 * 3_600_000);
  return `${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")}`;
};

export function HallRequests({ reqs, onCancel }: { reqs: HallReq[]; onCancel: (id: number) => void }) {
  const [open, setOpen] = useState(reqs.some((r) => r.status === "pending"));
  return (
    <div className={h.reqs}>
      <button type="button" className={h.toggle} onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        Заявки в ОО <span className={h.cnt}>({reqs.length})</span> {open ? "▴" : "▾"}
      </button>
      {open ? reqs.map((r) => (
        <div key={r.id} className={`${h.req} ${h[`st_${r.status}`] ?? ""}`}>
          <div className={h.reqHead}>
            <span className={h.reqText}>{r.summary}</span>
            <span className={h.reqStatus}>{STATUS[r.status]}</span>
          </div>
          <div className={h.reqMeta}>
            {r.requested_by_name} · {hhmm(r.requested_at)}{r.note ? ` · «${r.note}»` : ""}
            {r.decided_by_name ? ` → ${r.decided_by_name} ${hhmm(r.decided_at)}` : ""}{r.decision_note ? ` · ${r.decision_note}` : ""}
            {r.apply_result ? ` · ${r.apply_result}` : ""}
          </div>
          {r.status === "pending" ? <button type="button" className={h.link} onClick={() => onCancel(r.id)}>Отозвать</button> : null}
        </div>
      )) : null}
    </div>
  );
}
